export default __webpack_public_path__ + "static/media/Menu1.961d6451.png";